import React, { useState, useEffect } from 'react';
import styles from './BotoneraFiltros.module.css';

const BotoneraFiltros = (props) => {
  const filtros = props.filtros;
  const selected = props.selected;
  const [esMobile, setEsMobile] = useState(window.innerWidth < 600);

  useEffect(() => {
    const handleResize = () => {
      setEsMobile(window.innerWidth < 600);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const FiltroHandler = (event) => {
    props.onFiltroElegido(event.target.value);
    // Al cambiar el filtro, volver a la primera página (0)
    if (typeof props.onResetPagina === 'function') {
      props.onResetPagina(0);
    }
  };

  if (!filtros) return null;

  // En mobile, mostrar un select más compacto
  if (esMobile && filtros.length > 4) {
    return (
      <div className={`${styles.cuadroFiltros}`}>
        <select value={selected} onChange={FiltroHandler} className={`${styles.selectFiltros}`}>
          {filtros.map((filtro) => (
            <option key={filtro.codigo} value={filtro.codigo}>
              {filtro.descripcion}
            </option>
          ))}
        </select>
      </div>
    );
  }

  // En desktop o si hay pocos filtros, mantener los botones
  return (
    <div className={`${styles.cuadroFiltros}`}>
      {filtros.map((filtro) => (
        <label
          key={filtro.codigo}
          className={`${styles.filtro} ${filtro.codigo === selected ? styles.selected : ''}`}
          title={filtro.descripcion}
        >
          <input
            type="radio"
            value={filtro.codigo}
            checked={filtro.codigo === selected}
            onChange={FiltroHandler}
            aria-label={filtro.descripcion}
          />
          {filtro.descripcion}
        </label>
      ))}
    </div>
  );
};

export default BotoneraFiltros;
